import { render, staticRenderFns } from "./ArticleCard.vue?vue&type=template&id=38130d88&"
import script from "./ArticleCard.vue?vue&type=script&lang=ts&"
export * from "./ArticleCard.vue?vue&type=script&lang=ts&"
import style0 from "./ArticleCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports